<template>
  <div>
    <v-toolbar v-if="supportsRefresh" flat dense color="secondary" dark>
      <v-spacer />
      <v-btn icon :loading="loading" @click="refresh">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <StationMap :allStations="dataSourceLocations" :zoom="zoom" :height="height" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import StationMap from '@/components/Map'

const dataSources = createNamespacedHelpers('datasource')

export default {
  name: 'MapWidget',
  components: {
    StationMap,
  },
  props: {
    widgetId: { type: String, required: true },
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loading: false,
      error: null,
    }
  },
  computed: {
    ...dataSources.mapGetters(['dataSourceLocations']),
    zoom() {
      return this.config.zoom || 10
    },
    height() {
      return this.config.height || '600'
    },
    supportsRefresh() {
      return false // This widget does not support refresh, but the toolbar is included for consistency with other widgets
    },
  },
  methods: {
    async initialize() {
      this.loading = false
      this.$store.dispatch('dashboard/setWidgetData', { widgetId: this.widgetId, data: true })
    },
    async refresh() {
      this.loading = true
      this.$store.dispatch('map/acquireAccessToken')
      this.loading = false
    },
  },
}
</script>
